// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"vW-z","hovered":"wW-z","hoverImage":"xW-z","mainImage":"yW-z","imageNoBackground":"zW-z","fullSizeImage":"AW-z"};